module.exports = __webpack_public_path__ + "img/Banner-RenderedLoops-dwnszd.f2d880f8.jpg";